/* CraftPK - product page: variants, add to cart, sticky bar, delivery estimate. 2026-10-19 */
(function () {
var root = document.querySelector('[data-cp-pdp]');
if (!root) return;
var q = function (s, c) { return (c || root).querySelector(s); };
var qa = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
var fmt = root.getAttribute('data-money') || 'Rs.{{amount}}';
function money(c) {
try { if (window.theme && theme.Currency && theme.Currency.formatMoney) return theme.Currency.formatMoney(c, theme.moneyFormat || fmt); } catch (e) {}
var p = (c / 100).toFixed(2).split('.');
var whole = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
if (k === 'amount_no_decimals') return whole;
if (k === 'amount_with_comma_separator') return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + p[1];
return whole + '.' + p[1];
});
}
/* ---------- Variants ---------- */
var variants = [];
try { variants = JSON.parse(q('[data-cp-variants]').textContent || '[]'); } catch (e) {}
var idInput = q('[data-cp-id]');
var opts = qa('[data-cp-opt]');
var sel = opts.map(function (o) { var a = o.querySelector('.cp-pill.is-active'); return a ? a.getAttribute('data-value') : null; });
var tAdd = root.getAttribute('data-t-add') || 'Add to cart';
var tSold = root.getAttribute('data-t-sold') || 'Sold out';
var tNa = root.getAttribute('data-t-na') || 'Unavailable';
var current = null;
variants.forEach(function (v) { if (idInput && String(v.id) === idInput.value) current = v; });
if (current && !current.available) { var dn0 = q('.cp-pdp__dyn'); if (dn0) dn0.style.display = 'none'; }
function match(v, skip) {
for (var j = 0; j < sel.length; j++) { if (j !== skip && v.options[j] !== sel[j]) return false; }
return true;
}
function findVariant() {
for (var i = 0; i < variants.length; i++) { if (match(variants[i], -1)) return variants[i]; }
return null;
}
function paintPills() {
opts.forEach(function (o, k) {
qa('.cp-pill', o).forEach(function (p) {
var val = p.getAttribute('data-value'), exists = false, avail = false;
variants.forEach(function (v) {
if (v.options[k] === val && match(v, k)) { exists = true; if (v.available) avail = true; }
});
p.classList.toggle('is-none', !exists);
p.classList.toggle('is-out', exists && !avail);
});
});
}
function setAtc(enabled, text) {
qa('[data-cp-atc]').forEach(function (b) { b.disabled = !enabled; });
qa('[data-cp-atc-text]').forEach(function (s) { s.textContent = text; });
}
function apply(v) {
current = v;
var err = q('[data-cp-err]'); if (err) err.hidden = true;
if (!v) { setAtc(false, tNa); var dn = q('.cp-pdp__dyn'); if (dn) dn.style.display = 'none'; return; }
if (idInput) idInput.value = v.id;
var sale = v.compare > v.price;
qa('[data-cp-price]').forEach(function (e) { e.textContent = money(v.price); });
var now = q('.cp-pdp__now'); if (now) now.classList.toggle('is-sale', sale);
qa('[data-cp-compare]').forEach(function (e) { e.hidden = !sale; if (sale) e.textContent = money(v.compare); });
var save = q('[data-cp-save]'); if (save) { save.hidden = !sale; if (sale) save.textContent = 'Save ' + money(v.compare - v.price); }
var badge = q('[data-cp-badge]'); if (badge) { badge.hidden = !sale; if (sale) badge.textContent = '-' + Math.floor((v.compare - v.price) * 100 / v.compare) + '%'; }
qa('[data-cp-sku]').forEach(function (e) { e.textContent = v.sku || ''; });
var skuWrap = q('.cp-pdp__sku'); if (skuWrap) skuWrap.hidden = !v.sku;
qa('[data-cp-vtitle]').forEach(function (e) { e.textContent = v.title; });
var st = q('[data-cp-stock]'), stt = q('[data-cp-stock-text]');
if (st && stt) {
var cls = 'is-in', txt = 'In stock';
if (!v.available) { cls = 'is-out'; txt = tSold; }
else if (v.qty !== null && v.qty > 0 && v.qty <= 5) { cls = 'is-low'; txt = 'Only ' + v.qty + ' left'; }
st.className = 'cp-stock ' + cls; stt.textContent = txt;
}
setAtc(v.available, v.available ? tAdd : tSold);
var dyn = q('.cp-pdp__dyn'); if (dyn) dyn.style.display = v.available ? '' : 'none';
if (v.media && window.cpGallery) window.cpGallery.goMedia(v.media);
try {
var url = new URL(window.location.href);
url.searchParams.set('variant', v.id);
window.history.replaceState({}, '', url.toString());
} catch (e) {}
}
opts.forEach(function (o, k) {
var label = q('[data-cp-opt-val]', o);
qa('.cp-pill', o).forEach(function (p) {
p.addEventListener('click', function () {
sel[k] = p.getAttribute('data-value');
qa('.cp-pill', o).forEach(function (x) { var on = x === p; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
if (label) label.textContent = sel[k];
var v = findVariant();
if (!v || !v.available) {
/* jump to the closest available combination for the value just picked */
for (var i = 0; i < variants.length; i++) {
var c = variants[i];
if (c.available && c.options[k] === sel[k]) { v = c; break; }
}
if (v) {
sel = v.options.slice();
opts.forEach(function (oo, kk) {
qa('.cp-pill', oo).forEach(function (x) { var on = x.getAttribute('data-value') === sel[kk]; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
var l = q('[data-cp-opt-val]', oo); if (l) l.textContent = sel[kk];
});
}
}
paintPills();
apply(v || findVariant());
});
});
});
if (opts.length) paintPills();
/* ---------- Quantity ---------- */
var qtyBox = q('[data-cp-qty]');
var qty = qtyBox && qtyBox.querySelector('input');
if (qtyBox) {
qa('[data-cp-step]', qtyBox).forEach(function (b) {
b.addEventListener('click', function () {
var n = (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-cp-step'), 10);
if (current && current.qty !== null && current.qty > 0) n = Math.min(n, current.qty);
qty.value = Math.max(1, n);
});
});
qty.addEventListener('change', function () { qty.value = Math.max(1, parseInt(qty.value, 10) || 1); });
}
/* ---------- Add to cart ---------- */
var form = q('.cp-pdp__form');
function add(btn) {
if (!idInput || !current || !current.available) return;
var all = qa('[data-cp-atc]');
var err = q('[data-cp-err]');
all.forEach(function (b) { b.classList.add('is-busy'); });
qa('[data-cp-atc-text]').forEach(function (s) { s.textContent = 'Adding…'; });
fetch('/cart/add.js', {
method: 'POST', credentials: 'same-origin',
headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
body: JSON.stringify({ items: [{ id: parseInt(idInput.value, 10), quantity: Math.max(1, parseInt(qty && qty.value, 10) || 1) }] })
})
.then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
.then(function () {
if (window.CartJS && typeof window.CartJS.getCart === 'function') window.CartJS.getCart();
all.forEach(function (b) { b.classList.remove('is-busy'); b.classList.add('is-done'); });
qa('[data-cp-atc-text]').forEach(function (s) { s.textContent = 'Added to cart'; });
var d = document.getElementById('cart-drawer');
if (d) setTimeout(function () { d.classList.add('active'); }, 250);
setTimeout(function () {
all.forEach(function (b) { b.classList.remove('is-done'); });
qa('[data-cp-atc-text]').forEach(function (s) { s.textContent = current && current.available ? tAdd : tSold; });
}, 1800);
})
.catch(function (e) {
all.forEach(function (b) { b.classList.remove('is-busy'); });
qa('[data-cp-atc-text]').forEach(function (s) { s.textContent = tAdd; });
if (err) { err.textContent = (e && (e.description || e.message)) || 'Could not add to cart. Please try again.'; err.hidden = false; }
});
}
qa('[data-cp-atc]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); add(b); }); });
if (form) {
document.addEventListener('submit', function (e) {
if (e.target === form) { e.preventDefault(); e.stopImmediatePropagation(); add(); }
}, true);
}
/* ---------- Sticky bar ---------- */
var satc = q('[data-cp-satc]');
var buy = q('[data-cp-buy]');
var floaters = null;
function liftFloaters(on) {
if (on && !floaters) {
floaters = [];
qa('a[href*="wa.me"],a[href*="whatsapp"],[class*="whatsapp"],[id*="whatsapp"]', document).forEach(function (el) {
if (root.contains(el)) return;
for (var n = el, d = 0; n && n !== document.body && d < 5; d++, n = n.parentElement) {
if (getComputedStyle(n).position === 'fixed') { if (floaters.indexOf(n) < 0) floaters.push(n); break; }
}
});
}
(floaters || []).forEach(function (n) {
n.style.transition = 'transform .4s ease';
n.style.transform = on ? 'translateY(-' + (satc.offsetHeight + 8) + 'px)' : '';
});
}
if (satc && buy) {
var footer = document.getElementById('shopify-section-footer') || document.querySelector('footer');
var stTick = false;
var sync = function () {
stTick = false;
var pastBuy = buy.getBoundingClientRect().bottom < 0;
var atFooter = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
var show = pastBuy && !atFooter;
if (satc.classList.contains('is-on') === show) return;
satc.classList.toggle('is-on', show);
satc.setAttribute('aria-hidden', show ? 'false' : 'true');
document.documentElement.classList.toggle('cp-satc-on', show);
liftFloaters(show);
};
window.addEventListener('scroll', function () { if (!stTick) { stTick = true; requestAnimationFrame(sync); } }, { passive: true });
window.addEventListener('resize', sync);
sync();
}
/* ---------- Accordion jumps ---------- */
qa('[data-cp-jump]').forEach(function (a) {
a.addEventListener('click', function (e) {
var t = document.querySelector(a.getAttribute('href'));
if (!t) return;
e.preventDefault();
if (t.tagName === 'DETAILS') t.open = true;
var y = t.getBoundingClientRect().top + window.pageYOffset - 110;
window.scrollTo({ top: y, behavior: 'smooth' });
});
});
/* ---------- Wishlist state ---------- */
var wl = q('.addto-wishlist');
if (wl) {
var handle = wl.getAttribute('rel');
var inList = function () { var m = document.cookie.match(/(?:^|; )wishlistList=([^;]*)/); return m ? decodeURIComponent(m[1]).split('__').indexOf(handle) > -1 : false; };
var mark = function () {
wl.classList.remove('addto-wishlist');
wl.style.setProperty('color', 'var(--cp-sale,#3b663c)', 'important');
var ic = wl.querySelector('svg'); if (ic) ic.setAttribute('fill', 'currentColor');
var s = wl.querySelector('span'); if (s) s.textContent = 'In your wishlist';
};
if (inList()) mark();
else wl.addEventListener('click', function () { setTimeout(function () { if (inList()) mark(); }, 400); });
}
/* ---------- Share ---------- */
var share = q('[data-cp-share]');
if (share) {
share.addEventListener('click', function () {
var url = share.getAttribute('data-url'), title = share.getAttribute('data-title');
var label = q('[data-cp-share-text]', share);
if (navigator.share) { navigator.share({ title: title, url: url }).catch(function () {}); return; }
if (navigator.clipboard) {
navigator.clipboard.writeText(url).then(function () {
if (label) { label.textContent = 'Link copied'; setTimeout(function () { label.textContent = 'Share'; }, 1800); }
});
}
});
}
/* ---------- Delivery estimate (Sundays off) ---------- */
var eta = q('[data-cp-eta]');
if (eta) {
var min = parseInt(eta.getAttribute('data-min'), 10) || 3, max = parseInt(eta.getAttribute('data-max'), 10) || 5;
var addWork = function (n) { var d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) n--; } return d; };
var f = function (d) { return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }); };
var p = q('[data-cp-eta-text]', eta);
if (p) p.innerHTML = 'Order today, get it between <b>' + f(addWork(min)) + '</b> and <b>' + f(addWork(max)) + '</b>';
}
})();